<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：会员-添加
      -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
  <el-form
      size="small"
      :model="form"
      :rules="rules"
      ref="form"
      v-loading="formLoading"
    >

    <el-form-item label="应用名称" :label-width="formLabelWidth" prop="name">
        <el-input type="text" v-model="form.name"  autocomplete="off" ></el-input>
      </el-form-item>

      <el-form-item label="应用编码" :label-width="formLabelWidth" prop="code">
        <el-input type="text" v-model="form.code" :disabled="true" autocomplete="off" ></el-input>
        <div>只能输入英文</div>
      </el-form-item>

      <el-form-item label="编码驼峰大小写" :label-width="formLabelWidth" prop="code_upper">
        <el-input type="text" v-model="form.code_upper" autocomplete="off" ></el-input>
        <div>只能输入英文</div>
      </el-form-item>


      <el-form-item label="前端生成目录路径" :label-width="formLabelWidth" prop="webpath">
        <el-input type="text" v-model="form.webpath" autocomplete="off" ></el-input>
      </el-form-item>


      <el-form-item label="应用版本" :label-width="formLabelWidth" prop="version">
        <el-input type="text" v-model="form.version" autocomplete="off" ></el-input>

      </el-form-item>



      <el-form-item label="状态代码" :label-width="formLabelWidth" prop="status_val">
        <el-input v-model="form.status_val" type="textarea" placeholder="public function getUseAttr($value){
        $status = [0 => '未使用', 1 => '已使用'];
        return ['text' => $status[$value], 'value' => $value];
    }" :rows="8" ></el-input>

      </el-form-item>

      <el-form-item label="是否使用" :label-width="formLabelWidth" prop="use">
        <el-radio-group v-model="form.use">
                <el-radio  :label="0" :value = "0">未使用</el-radio>
                <el-radio  :label="1" :value = "1">已使用</el-radio>
            </el-radio-group>

      </el-form-item>


      <el-form-item label="说明" :label-width="formLabelWidth" prop="version">
        应用完成后，请自行上传git
      </el-form-item>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitApi" :loading="loading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import LapplyApi from "@/api/lapply.js";
import { deepClone } from "@/utils/base.js";

export default {
  data() {
    return {
      form: {
        name:"",
        code:"",//编码
        version:"1.0.0",//版本
        use:0,//使用使用
        status_val:"",
        code_upper:"",//编码驼峰大小写
      },
      rules: {
        "name": [
          { required: true, message: "请输入名称", trigger: "blur" }
        ],
        "code": [
          { required: true, message: "请输入编码", trigger: "blur" }
        ],
        "version": [
          { required: true, message: "请输入版本", trigger: "blur" }
        ],

      },
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /* 类型 */
      typeList: [],
      /* 表单Items */
      formItems: null,
      formLoading: false
    };
  },
  props: ["open_edit", "model"],
  computed: {
    title() {
      return this.model ? "编辑接口" : "添加接口";
    }
  },
  created() {
    this.init();
  },
  methods: {
    /* 初始化数据 */
    async init() {
      this.dialogVisible = this.open_edit;
      if (this.model) {
        this.form = deepClone(this.model);
      }

    },





    // 提交api表单
    submitApi() {
      var self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          LapplyApi.edit(self.form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.dialogFormVisible()
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          return false;
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/lapply/index/edit.vue